import {BasicDataTable, BasicDataTableConfig, TypedColumnSettings} from "@/shared/ui/basicDataTable";
import {RequestParam} from "@/shared/api";
import {formatDateRange, parseISODate} from "@/shared/utils/datefunctions";
import {WorkingTimeDateSpan} from "@/shared/timr";

export class WorkingTimeDateSpanRevisionsTable extends BasicDataTable<WorkingTimeDateSpan> {

	private static COLUMN_DATE = "160px";

	constructor(public config: BasicDataTableConfig) {
		super("/timr/workingTimeDateSpans/findWorkingTimeDateSpanRevisions.json", config);
	}

	public static buildFilterParams(workingTimeDateSpanId: number): RequestParam[] {
		return [{
			name: "workingTimeDateSpanId",
			value: workingTimeDateSpanId
		}];
	}

	public filterByWorkingTimeDateSpanId(workingTimeDateSpanId: number) {
		return this.filter(WorkingTimeDateSpanRevisionsTable.buildFilterParams(workingTimeDateSpanId));
	}

	protected getColumnSettings(): TypedColumnSettings<WorkingTimeDateSpan>[] {
		return [
			{
				data: "lastModified",
				orderable: this.config.orderable,
				render: BasicDataTable.renderDateTimeLocal,
				visible: true,
				width: WorkingTimeDateSpanRevisionsTable.COLUMN_DATE
			},
			{data: "modifiedByUser.fullname", orderable: this.config.orderable, render: BasicDataTable.renderText},
			{data: "workingTimeType.name", orderable: false, render: BasicDataTable.renderText},
			{data: "start", orderable: false, render: this.renderDateRange},
			{
				data: "description",
				className: "table-data-description",
				orderable: this.config.orderable,
				render: BasicDataTable.renderDescriptionText
			}
		];
	}

	protected renderDateRange(this: void, data: string, type: string, workingTimeDateSpan: WorkingTimeDateSpan, meta: DataTables.CellMetaSettings) {
		return formatDateRange(parseISODate(workingTimeDateSpan.start), parseISODate(workingTimeDateSpan.end), workingTimeDateSpan.startHalfDay, workingTimeDateSpan.endHalfDay);
	}

	protected getDefaultOrder(): (string | number)[][] {
		return [[0, "asc"]];
	}

	protected createDataTableConfig(): DataTables.Settings {
		return {
			pageLength: 4,
			deferLoading: 0,
			dom: `rt`
		};
	}
}
